'use strict';

var React = require('react');

var SvgBillingStatementRupeeMajor = function SvgBillingStatementRupeeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0h11c.828 0 1.5.677 1.5 1.512v18.21a.2.2 0 0 1-.334.149l-1.664-1.515a.497.497 0 0 0-.67 0l-1.664 1.514a.497.497 0 0 1-.67 0l-1.663-1.514a.497.497 0 0 0-.67 0l-1.663 1.514a.497.497 0 0 1-.67 0l-1.664-1.514a.497.497 0 0 0-.67 0l-1.664 1.515a.2.2 0 0 1-.334-.15v-18.209c0-.835.672-1.512 1.5-1.512zm6.808 13.4-1.96-2.63c1.342-.21 2.254-1.288 2.552-2.694h.85a.75.75 0 1 0 0-1.499h-.763a4.427 4.427 0 0 0-.432-1.579h.945a1 1 0 1 0 0-1.998h-5a1 1 0 1 0 0 1.998h2.135c.449.297.754.86.844 1.58h-3.229a.75.75 0 1 0 0 1.498h3.1c-.252.756-.791 1.234-1.493 1.234-.285 0-.543-.02-.777-.056a1 1 0 0 0-1.258 1.489l2.89 3.86a1 1 0 0 0 1.596-1.204z"
  }));
};

exports.SvgBillingStatementRupeeMajor = SvgBillingStatementRupeeMajor;
